export default function HamburgerMenu() {
  return (
    <svg
      width="23"
      height="22"
      viewBox="0 0 23 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="2.53493"
        y="4.3999"
        width="17.6"
        height="2.2"
        rx="0.5"
        fill="white"
      />
      <rect
        x="2.53493"
        y="9.8999"
        width="17.6"
        height="2.2"
        rx="0.5"
        fill="white"
      />
      <rect
        x="2.53493"
        y="15.3999"
        width="17.6"
        height="2.2"
        rx="0.5"
        fill="white"
      />
    </svg>
  );
}
